import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext.jsx';

const LoginHeader = () => {
  const { t } = useLanguage();
  return (
  <div className="text-center mb-8">
    <h1 className="text-3xl font-bold text-neutral-600 mb-2">
      {t('login.welcome')}
    </h1>
    <p className="text-base text-neutral-500 font-medium">
      {t('login.subtitle')}
    </p>
  </div>
  );
};

export default LoginHeader;
